import React from 'react';
import { connect } from 'react-redux';
import { loadSong } from '../actions/song';
import SongList from '../components/SongList';
import { openSongFromFireStore } from '../actions/firestore';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  songlist: state.songlist,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSelect: (filename) => {
    dispatch(openSongFromFireStore(filename)).then(() => {
      ownProps.history.push('/');
    });
  },
});

const SongListContainer = connect(mapStateToProps, mapDispatchToProps)(SongList);

export default SongListContainer;



// WEBPACK FOOTER //
// ./src/containers/SongListContainer.js